import { useState, useEffect } from 'react';
import PropertiesEnrollmentByAge from './PropertiesEnrollmentByAge';
import PropertiesTotalPremiumByPlanType from './PropertiesTotalPremiumByPlanType';
import PropertiesVideo from './PropertiesVideo';
import NewPropertiesMultimedia from './NewPropertiesMultimedia';
import ContentPropertiesMultimedia from './ContentPropertiesMultimedia';
import ButtonPropertiesMultimedia from './ButtonPropertiesMultimedia';
import NewPropertiesTable from './NewPropertiesTable';
import NewPropertiesDocument from './NewPropertiesDocument';
import PropertiesChildPortal from './PropertiesChildPortal';
import LinkPropertiesLink from './LinkPropertiesLink';
import FormatPropertiesLink from './FormatPropertiesLink';
import { fetchTemplateByID } from '../../services/templateService';
import Toast from '../ui/toasts/Toast';
import {
    SecurityAttributes,
    ContainerTypes,
    TenantTiers,
} from '../../utils/data/enums';
import { useAuthContext } from '../../store/AuthContext';
import NewPropertiesAssetUpload from './NewPropertiesAssetUpload';
import ContentPropertiesAssetUpload from './ContentPropertiesAssetUpload';
import RequestPropertiesAssetUpload from './RequestPropertiesAssetUpload';
import CustomDatePicker from '../helpers/CustomDatePicker_V2';
import Spinner from '../ui/spinners/Spinner';
import styles from '../individual/IndividualPage.module.scss';
import { validateUrlProtocol } from '../../utils/linkUrlValidation';
import { ROUTES } from '../../constants/routes';
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { getText } from '../../i18n';

export function NewerPropertiesModal({ dismissModal, item, onSave, portalId }) {
    const nameCharacterLimit = 50;
    const [containerTypeProperties, setContainerTypeProperties] = useState();
    const [nameCharacterLimitLabel, setNameCharacterLimitLabel] = useState(
        `Character Limit ${item.title?.length ?? 0}/${nameCharacterLimit}`,
    );
    const [nameCharacterLimitStatus, setNameCharacterLimitStatus] = useState(
        'rgba(47, 43, 67, 0.6)',
    );
    const [name, setName] = useState(item.title);
    const [dueDate, setDueDate] = useState(item.dueDate);
    const [acknowledgmentText, setAcknowledgmentText] = useState(
        item.acknowledgmentText || '',
    );
    const [helpBoxText, setHelpBoxText] = useState(item.helpBoxText || '');
    const [
        visibilityTextAreaAdditionalInformation,
        setVisibilityTextAreaAdditionalInformation,
    ] = useState(
        item.helpBoxText !== null &&
            item.helpBoxText !== '' &&
            item.helpBoxText !== undefined,
    );
    const [
        visibilityTextAreaAcknowledgementRequired,
        setVisibilityTextAreaAcknowledgementRequired,
    ] = useState(item.acknowledgmentType === 1);
    const [displayTitle, setDisplayTitle] = useState(item.displayTitle);
    const [isSaving, setIsSaving] = useState(false);
    const [newItem, setNewItem] = useState();
    const [newFile, setNewFile] = useState();
    const [newFiles, setNewFiles] = useState();
    const [uploadFromDevice, setUploadFromDevice] = useState('');
    const [addFromAssets, setAddFromAssets] = useState('');
    const [assetUploadHeaderState, setAssetUploadHeaderState] = useState({
        isNoneChecked: true,
        isImageChecked: false,
        isVideoChecked: false,
        imageAsset1: {},
        imageAsset2: {},
        imageAsset3: {},
        imageAsset4: {},
        videoAsset: {},
        videoUrl: '',
        isExternal: false,
        isInitialized: false,
    });
    const [assetUploadContentState, setAssetUploadContentState] = useState({
        text: '',
        textAssets: [],
        isInitialized: false,
    });
    const [assetUploadRequestState, setAssetUploadRequestState] = useState({
        selectedIndividuals: [],
        selectedAllowedFileTypeOption: [1],
        allowedFileTypes: [],
        isInitialized: false,
    });
    const [tableState, setTableState] = useState({
        tableAsset: {},
        data: '',
        assetName: '',
        assetUrl: '',
        assetFileType: '',
        isInitialized: false,
    });
    const [documentState, setDocumentState] = useState({
        documentAsset: {},
        caption: '',
        assetName: '',
        isInitialized: false,
    });
    const [linkState, setLinkState] = useState({
        isWebsiteChecked: true,
        isPortalChecked: false,
        isSSOChecked: false,
        isMenuChecked: false,
        linkUrl: '',
        childPortalId: null,
        tenantSSOId: null,
        menuRoute: '',
        isInitialized: false,
    });
    const [multimediaHeaderState, setMultimediaHeaderState] = useState({
        isNoneChecked: true,
        isImageChecked: false,
        isVideoChecked: false,
        imageAsset1: {},
        imageAsset2: {},
        imageAsset3: {},
        imageAsset4: {},
        videoAsset: {},
        videoUrl: '',
        isExternal: false,
        isInitialized: false,
    });
    const [multimediaContentState, setMultimediaContentState] = useState({
        text: '',
        textAssets: [],
        isInitialized: false,
    });
    const [multimediaButtonState, setMultimediaButtonState] = useState({
        isNoneChecked: true,
        isWebsiteChecked: false,
        isPortalChecked: false,
        isSSOChecked: false,
        buttonUrl: '',
        buttonText: '',
        childPortalId: null,
        tenantSSOId: null,
        isInitialized: false,
    });
    const [linkFormatState, setLinkFormatState] = useState({
        isDisplayIcon: true,
        selectedIcon: '',
        selectedBackgroundColor: '',
        selectedForegroundColor: '',
        buttonText: '',
        image: null,
        imageAsset: {},
        textAssets: [],
        initialText: '',
        text: '',
        isInitialized: false,
    });

    const [TABS, setTABS] = useState({
        GENERAL: 'General',
    });
    const { hasAttribute, clientTierMeetsRequirement } = useAuthContext();
    const [activeTab, setActiveTab] = useState(TABS.GENERAL);
    const overlayStyles = css`
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1001;
    `;

    useEffect(() => {
        if (item.type === ContainerTypes.AssetUpload) {
            setVisibilityTextAreaAdditionalInformation(true); //If container is assetUpload, additional information box is shown
            setTABS({
                GENERAL: 'General',
                HEADER: getText('msg_31341c6f0c7a'),
                CONTENT: 'Content',
                REQUEST: 'Request',
            });
            return;
        }

        if (
            item.type === ContainerTypes.Document ||
            item.type === ContainerTypes.Table
        ) {
            setTABS({
                GENERAL: 'General',
                UPLOAD: 'Upload',
            });
            return;
        }

        if (item.type === ContainerTypes.Link) {
            setTABS({
                GENERAL: 'General',
                LINK: 'Link',
                FORMAT: 'Format',
            });
            return;
        }

        if (item.type === ContainerTypes.Multimedia) {
            setTABS({
                GENERAL: 'General',
                HEADER: getText('msg_31341c6f0c7a'),
                CONTENT: 'Content',
                BUTTON: 'Button',
            });
            return;
        }
    }, []);

    useEffect(() => {
        if (item !== null && item !== undefined) {
            //If item is new from template, populate properties with template data from instance stored in backend
            if (item.isTemplate) {
                fetchTemplateByID(item.id).then(n => {
                    let newItem = n;
                    if (item.templateStatus !== -1) {
                        // TODO: This needs to be fixed, this code is a temporary patch because the status of a template is -1 which makes the properties modal render as disabled,
                        // so we are forcing the status to be a hardcoded one so this feature can be tested
                        newItem.templateStatus = item.templateStatus;
                    }
                    setNewItem(newItem);
                });
            }
            //If item is already placed on the grid, populate the properties with the stored item's data
            else {
                setNewItem(item);
            }
        }
    }, [item]);

    useEffect(() => {
        if (newItem) {
            setContainerTypeProperties(newItem.content || newItem.name);

            if (newItem.acknowledgmentType === 1) {
                setVisibilityTextAreaAcknowledgementRequired(true);
                setAcknowledgmentText(newItem.acknowledgmentText || '');
            }

            if (
                newItem.helpBoxText !== null &&
                newItem.helpBoxText !== '' &&
                newItem.helpBoxText !== undefined
            ) {
                setVisibilityTextAreaAdditionalInformation(true);
                setHelpBoxText(newItem.helpBoxText);
            }
        }
    }, [newItem]);

    function renderContainerSpecificFields() {
        if (!newItem) {
            return null;
        }

        const containerType = newItem.containerType || newItem.type;

        const componentMap = {
            [ContainerTypes.EnrollmentByAge]: (
                <PropertiesEnrollmentByAge
                    item={newItem}
                    setItem={setNewItem}
                />
            ),
            [ContainerTypes.PremiumByPlanType]: (
                <PropertiesTotalPremiumByPlanType
                    item={newItem}
                    setItem={setNewItem}
                />
            ),
            [ContainerTypes.Video]: (
                <PropertiesVideo
                    item={newItem}
                    setItem={setNewItem}
                    setUploadFile={setNewFile}
                />
            ),
            [ContainerTypes.Multimedia]: (
                <NewPropertiesMultimedia
                    item={newItem}
                    setItem={setNewItem}
                    setUploadFile={setNewFiles}
                    handleUploadFromDevice={setUploadFromDevice}
                    handleAddFromAssets={setAddFromAssets}
                    setIsSaving={setIsSaving}
                    headerState={multimediaHeaderState}
                    setHeaderState={setMultimediaHeaderState}
                    portalId={portalId}
                />
            ),
            [ContainerTypes.ChildPortal]: (
                <PropertiesChildPortal
                    item={newItem}
                    setItem={setNewItem}
                    setUploadFile={setNewFiles}
                    handleUploadFromDevice={setUploadFromDevice}
                    handleAddFromAssets={setAddFromAssets}
                    setIsSaving={setIsSaving}
                    portalId={portalId}
                />
            ),
            [ContainerTypes.AssetUpload]: (
                <NewPropertiesAssetUpload
                    item={newItem}
                    setItem={setNewItem}
                    setUploadFile={setNewFiles}
                    handleUploadFromDevice={setUploadFromDevice}
                    handleAddFromAssets={setAddFromAssets}
                    setIsSaving={setIsSaving}
                    headerState={assetUploadHeaderState}
                    setHeaderState={setAssetUploadHeaderState}
                    portalId={portalId}
                />
            ),
        };

        return componentMap[containerType] || null;
    }

    function renderContentProperties() {
        if (!newItem) {
            return null;
        }

        const containerType = newItem.containerType || newItem.type;

        if (containerType === ContainerTypes.AssetUpload) {
            return (
                <ContentPropertiesAssetUpload
                    item={newItem}
                    setItem={setNewItem}
                    setIsSaving={setIsSaving}
                    contentState={assetUploadContentState}
                    setContentState={setAssetUploadContentState}
                    portalId={portalId}
                />
            );
        }

        if (containerType === ContainerTypes.Multimedia) {
            return (
                <ContentPropertiesMultimedia
                    item={newItem}
                    setItem={setNewItem}
                    setUploadFile={setNewFiles}
                    handleUploadFromDevice={setUploadFromDevice}
                    handleAddFromAssets={setAddFromAssets}
                    setIsSaving={setIsSaving}
                    contentState={multimediaContentState}
                    setContentState={setMultimediaContentState}
                    portalId={portalId}
                />
            );
        }

        return null;
    }

    function renderButtonProperties() {
        if (!newItem) {
            return null;
        }

        const containerType = newItem.containerType || newItem.type;

        if (containerType === ContainerTypes.Multimedia) {
            return (
                <ButtonPropertiesMultimedia
                    item={newItem}
                    setItem={setNewItem}
                    buttonState={multimediaButtonState}
                    setButtonState={setMultimediaButtonState}
                    portalId={portalId}
                />
            );
        }

        return null;
    }

    function renderUploadProperties() {
        if (!newItem) {
            return null;
        }

        const containerType = newItem.containerType || newItem.type;

        if (containerType === ContainerTypes.Document) {
            return (
                <NewPropertiesDocument
                    item={newItem}
                    setItem={setNewItem}
                    handleUploadFromDevice={setUploadFromDevice}
                    handleAddFromAssets={setAddFromAssets}
                    setIsSaving={setIsSaving}
                    documentState={documentState}
                    setDocumentState={setDocumentState}
                />
            );
        }

        if (containerType === ContainerTypes.Table) {
            return (
                <NewPropertiesTable
                    item={newItem}
                    setItem={setNewItem}
                    handleUploadFromDevice={setUploadFromDevice}
                    handleAddFromAssets={setAddFromAssets}
                    setIsSaving={setIsSaving}
                    tableState={tableState}
                    setTableState={setTableState}
                />
            );
        }

        return null;
    }

    function renderRequestProperties() {
        if (!newItem) {
            return null;
        }

        const containerType = newItem.containerType || newItem.type;

        if (containerType === ContainerTypes.AssetUpload) {
            return (
                <RequestPropertiesAssetUpload
                    item={newItem}
                    setItem={setNewItem}
                    requestState={assetUploadRequestState}
                    setRequestState={setAssetUploadRequestState}
                />
            );
        }

        return null;
    }

    function renderLinkProperties() {
        if (!newItem) {
            return null;
        }

        const containerType = newItem.containerType || newItem.type;

        if (containerType === ContainerTypes.Link) {
            return (
                <LinkPropertiesLink
                    item={newItem}
                    setItem={setNewItem}
                    linkState={linkState}
                    setLinkState={setLinkState}
                    portalId={portalId}
                />
            );
        }

        return null;
    }

    function renderFormatProperties() {
        if (!newItem) {
            return null;
        }

        const containerType = newItem.containerType || newItem.type;

        if (containerType === ContainerTypes.Link) {
            return (
                <FormatPropertiesLink
                    item={newItem}
                    setItem={setNewItem}
                    formatState={linkFormatState}
                    setFormatState={setLinkFormatState}
                    handleUploadFromDevice={setUploadFromDevice}
                    handleAddFromAssets={setAddFromAssets}
                    setIsSaving={setIsSaving}
                />
            );
        }

        return null;
    }

    const saveChanges = async () => {
        let draggedItem = JSON.parse(JSON.stringify(newItem));
        if (item.content === null)
            return Toast.error(
                getText('msg_f5b27f0ceb28'),
            );

        item.name = newItem.name;
        item.title = name;
        item.dueDate = dueDate;
        item.height = item.width = 0;
        item.order = item.container;
        item.populationGroups = [];
        item.type = newItem.type;
        item.displayTitle = displayTitle;

        draggedItem.name = item.content;
        draggedItem.title = name;
        draggedItem.dueDate = dueDate;
        draggedItem.height = draggedItem.width = 0;
        draggedItem.order = item.container;
        draggedItem.populationGroups = [];
        draggedItem.type = item.containerType;
        draggedItem.displayTitle = displayTitle;

        //TODO: a hack to get this code to work. anything that touches this, directly or indirectly, should be rewritten.
        [
            'ageBandParts',
            'premiumByPlanTypePart',
            'premiumExplodedPart',
            'videoPart',
            'contactsPart',
            'documentPart',
            'multimediaPart',
            'childPortalPart',
            'assetUploadPart',
            'linkPart',
            'containerAssets',
        ].forEach(partKey => {
            if (newItem[partKey]) {
                //good ol' javascript deep copy
                item[partKey] = JSON.parse(JSON.stringify(newItem[partKey]));
            }
        });

        if (newItem['applyDataFilter'] !== undefined) {
            item['applyDataFilter'] = newItem['applyDataFilter']; // true or false
        }

        if (visibilityTextAreaAcknowledgementRequired) {
            item.acknowledgmentType = 1;
            if (acknowledgmentText !== '') {
                item.acknowledgmentText = acknowledgmentText;
            } else {
                item.acknowledgmentText =
                    'Additional text to go here with information on what the user is acknowledging or agreeing. This box will remain red until the task below has been completed.';
            }
        } else {
            item.acknowledgmentType = 0;
            item.acknowledgmentText = acknowledgmentText;
        }

        if (visibilityTextAreaAdditionalInformation && helpBoxText !== '') {
            item.helpBoxText = helpBoxText;
        } else {
            item.helpBoxText = '';
        }

        switch (item.type) {
            case ContainerTypes.EnrollmentByAge:
                item.height = 540;
                item.width = 480;
                break;
            case ContainerTypes.PremiumByPlanType:
                item.height = 540;
                item.width = 540;
                break;
            case ContainerTypes.Video:
                item.height = 530;
                item.width = 738;
                break;
            case ContainerTypes.Text:
                item.height = 356;
                item.width = 446;
                break;
            case ContainerTypes.Location:
            case ContainerTypes.Image:
            case ContainerTypes.Table:
            case ContainerTypes.Document:
            case ContainerTypes.Multimedia:
                item.height = 246;
                item.width = 326;
                break;
            case ContainerTypes.ChildPortal:
            case ContainerTypes.Link:
                item.height = 300;
                item.width = 300;
                break;
            case ContainerTypes.AssetUpload:
                item.height = 246;
                item.width = 326;
                if (item.dueDate === null || item.dueDate === '') {
                    return Toast.error(getText('msg_745a1736d956'));
                }
                break;
        }
        if (item.title === null || item.title === '') {
            return Toast.error(getText('msg_d5ec4d31ee0f'));
        } else if (item.title.length > nameCharacterLimit) {
            return Toast.error(
                `Title cannot exceed ${nameCharacterLimit} characters.`,
            );
        }

        //delete item.containerType;
        delete item.content;
        delete item.container;
        delete item.isPlaced;
        //delete item.id;

        setVisibilityTextAreaAcknowledgementRequired(false);
        setVisibilityTextAreaAdditionalInformation(false);
        //TODO: Add spinner while this loads
        //TODO: Add error handling if file does not upload correctly
        if (item.containerAssets) {
            //Filter out empty entries
            item.containerAssets = item.containerAssets.filter(
                asset => Object.keys(asset).length > 0,
            );

            //Add/Remove properties
            item.containerAssets = item.containerAssets.map((asset, index) => {
                const { url, assetTypeId, ...rest } = asset;
                return {
                    ...rest,
                    assetOrder: index + 1,
                    containerId: draggedItem.id ?? 0,
                };
            });
            draggedItem.containerAssets = item.containerAssets;
        }
        if (
            item.containerType === ContainerTypes.Document &&
            item.containerAssets.length === 0
        ) {
            Toast.error(getText('msg_7e184124bef0'));
            return;
        } else if (
            (item.containerType === ContainerTypes.Table ||
                item.type === ContainerTypes.Table) &&
            item.containerAssets.length === 0
        ) {
            Toast.error(getText('msg_7e184124bef0'));
            return;
            //Upload video
        } else if (item.videoPart && !item.videoPart.isExternal) {
            Toast.error(getText('msg_f0fea8b740fc'));
            return;
            //Uploading one or more images
        } else if (
            item.containerType === ContainerTypes.Multimedia ||
            item.type === ContainerTypes.Multimedia
        ) {
            if (!item.multimediaPart) item.multimediaPart = {};
            if (
                !multimediaButtonState.isNoneChecked &&
                multimediaButtonState.buttonText === ''
            ) {
                Toast.error(getText('msg_111f38f95a86'));
                return;
            }
            if (
                multimediaButtonState.isWebsiteChecked &&
                multimediaButtonState.buttonUrl === ''
            ) {
                Toast.error(getText('msg_da93265d63cc'));
                return;
            }
            if (
                multimediaButtonState.isPortalChecked &&
                multimediaButtonState.childPortalId === null
            ) {
                Toast.error(getText('msg_3225cdd9d0ad'));
                return;
            }
            if (
                multimediaButtonState.isSSOChecked &&
                multimediaButtonState.tenantSSOId === null
            ) {
                Toast.error(getText('msg_4c73483e8525'));
                return;
            }
            if (item.multimediaPart.imageChecked === true) {
                if (item.containerAssets.length) {
                    delete item.multimediaPart.imageChecked;
                    delete item.multimediaPart.videoChecked;
                    onSave(item);
                    dismissModal(true, draggedItem);
                } else {
                    Toast.error(getText('msg_2b26f6464e27'));
                }
            } else {
                delete item.multimediaPart.imageChecked;
                delete item.multimediaPart.videoChecked;
                onSave(item);
                dismissModal(true, draggedItem);
            }
            //Uploading one image for child portal
        } else if (
            item.childPortalPart &&
            item.childPortalPart.glyph === null &&
            item.childPortalPart.images !== null
        ) {
            onSave(item);
            dismissModal(true, draggedItem);
            //Uploading one image for link
        } else if (
            item.linkPart ||
            item.containerType === ContainerTypes.Link ||
            item.type === ContainerTypes.Link
        ) {
            let errorMessage = '';
            const noUrl =
                item.linkPart?.url == null || item.linkPart?.url == '';
            const noPortal =
                item.linkPart?.childPortalId == null ||
                item.linkPart?.childPortalId == '';
            const noSSO =
                item.linkPart?.tenantSSOId == null ||
                item.linkPart?.tenantSSOId == '';
            const noGlyph =
                item.linkPart?.glyph == null || item.linkPart?.glyph == '';
            const noImage =
                item.linkPart?.image == null || item.linkPart?.image == '';
            const isFormatInitialized = linkFormatState.isInitialized;
            const isButtonSelected = isFormatInitialized
                ? linkFormatState.isDisplayIcon === true
                : !noGlyph;
            const isFormatMissing = isFormatInitialized
                ? !isButtonSelected && noImage
                : noGlyph && noImage;

            if (noUrl && noSSO && noPortal) {
                errorMessage = 'URL, Portal, SSO or Menu are required';
            } else if (isFormatMissing) {
                errorMessage = 'Button or Image is required';
            } else if (isButtonSelected && noGlyph) {
                errorMessage = 'Icon is required';
            }
            if (errorMessage !== '') return Toast.error(errorMessage);

            const menuRoutes = [
                ROUTES.MY_BENEFITS,
                ROUTES.MY_MESSAGES,
                ROUTES.MY_ASSETS,
            ];
            const isMenuRoute = menuRoutes.includes(item.linkPart?.url);
            if (!noUrl && !isMenuRoute) {
                try {
                    const result = validateUrlProtocol(item.linkPart?.url);

                    if (!result.valid) {
                        Toast.error(result.error);
                        return;
                    }
                } catch (e) {
                    Toast.error(getText('msg_171e5cc5487e'));
                    return;
                }
            }

            onSave(item);
            dismissModal(true, draggedItem);
            //uploading one or more images for asset uploader
        } else if (
            item.assetUploadPart ||
            item.containerType === ContainerTypes.AssetUpload
        ) {
            if (
                item?.assetUploadPart?.assetUploadPartSharingIndividuals ===
                    null ||
                item?.assetUploadPart?.assetUploadPartSharingIndividuals ===
                    undefined ||
                !item?.assetUploadPart?.assetUploadPartSharingIndividuals.length
            )
                return Toast.error(getText('msg_c97ef4bea824'));
            onSave(item);
            dismissModal(true, draggedItem);
        } else {
            onSave(item);
            dismissModal(true, draggedItem);
        }
    };

    const handleNameChange = event => {
        setName(event.target.value);
        handleNameCharacterLimit(event);
    };

    const handleDueDateChange = dateString => {
        if (dateString?.length >= 10) {
            const [year, month, day] = dateString.split('-');
            const isoDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T06:00:00Z`;
            setDueDate(isoDate);
        } else {
            setDueDate(null);
        }
    };

    const handleNameCharacterLimit = event => {
        var str = event.target.value.toString();
        if (str.length > nameCharacterLimit) {
            setNameCharacterLimitStatus('rgba(239, 78, 69, 1)');
        } else {
            setNameCharacterLimitStatus('rgba(47, 43, 67, 0.6)');
        }
        setNameCharacterLimitLabel(
            'Character Limit ' + str.length + '/' + nameCharacterLimit,
        );
    };

    return (
        <>
            <div css={overlayStyles} />
            <div
                style={{
                    position: 'absolute',
                    left: '0',
                    right: '0',
                    top: '0',
                    bottom: '0',
                    margin: 'auto',
                    zIndex: '1002',
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <div
                    className="card shadow-sm border-light"
                    style={{
                        width: '100%',
                        maxWidth: '950px',
                        height: '100%',
                        maxHeight: '700px',
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    {isSaving && (
                        <div
                            style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                zIndex: 1000,
                                pointerEvents: 'auto',
                            }}
                        >
                            <Spinner
                                width={50}
                                className={styles.loadingSpinner}
                            />
                        </div>
                    )}

                    <div
                        id="header"
                        style={{
                            position: 'relative',
                            height: 'fit-content',
                            width: '100%',
                            padding: '28px 28px 0 28px',
                            display: isSaving ? 'none' : 'block',
                        }}
                    >
                        <p style={{ fontSize: '20px', fontWeight: '600' }}>
                            {uploadFromDevice
                                ? 'Upload Asset'
                                : addFromAssets
                                  ? 'Add from Assets'
                                  : 'Container Properties'}
                        </p>
                        <p
                            style={{
                                fontSize: '16px',
                                fontWeight: '500',
                                color: 'rgba(47, 43, 67, 0.6)',
                            }}
                        >
                            {uploadFromDevice
                                ? 'Upload will be added to Assets. Navigate to Assets menu if you wish to edit additional properties.'
                                : addFromAssets
                                  ? ''
                                  : containerTypeProperties}
                        </p>
                        <button
                            type="button"
                            onClick={() => dismissModal(false, item)}
                            className="ing-text-buttons-save absolute-position pointer-cursor"
                            style={{
                                position: 'absolute',
                                top: '28px',
                                right: '28px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                color: 'rgba(102, 112, 133, 1)',
                                background: 'none',
                                border: 'none',
                                padding: 0,
                                cursor: 'pointer',
                            }}
                        >
                            <i
                                className="bi bi-x"
                                style={{ fontSize: '1.2rem' }}
                            />
                            {getText('msg_bbfa773e5a63')}
                        </button>
                        <br />
                    </div>
                    <hr
                        style={{
                            margin: '0px',
                            color: 'rgba(217, 217, 217, 1)',
                            display: isSaving ? 'none' : 'block',
                        }}
                    />

                    {!(uploadFromDevice || addFromAssets) && (
                        <div className="d-flex justify-content-between align-items-center position-relative mt-3">
                            <ul
                                className={`col-md-4 col-lg-4 ${styles.containerTabList}`}
                            >
                                {Object.values(TABS).map(tab => (
                                    <li
                                        key={tab}
                                        className={`${styles.tabItem} ${
                                            activeTab === tab
                                                ? styles.active
                                                : ''
                                        }`}
                                        onClick={() => setActiveTab(tab)}
                                    >
                                        {tab}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    <hr
                        style={{
                            margin: '0px',
                            color: 'rgba(217, 217, 217, 1)',
                            display: isSaving ? 'none' : 'block',
                        }}
                    />

                    <div
                        id="properties"
                        style={{
                            flexGrow: 1,
                            overflowY: 'auto',
                            width: '100%',
                            padding: '28px 28px',
                            display: isSaving ? 'none' : 'block',
                        }}
                    >
                        {/*CONTAINER-STANDARD PROPERTY FIELDS SECTION*/}
                        {activeTab === TABS.GENERAL && (
                            <div
                                style={{
                                    width: '100%',
                                    paddingTop: '6px',
                                    display:
                                        uploadFromDevice || addFromAssets
                                            ? 'none'
                                            : 'block',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: '16px',
                                            fontWeight: '500',
                                            color: 'rgba(47, 43, 67, 1)',
                                            marginBottom: '10px',
                                        }}
                                    >
                                        {getText('msg_768e0c1c6957')}
                                        <span
                                            style={{
                                                color: '#EF4E45',
                                                marginLeft: '4px',
                                                fontWeight: '500',
                                            }}
                                        >
                                            *
                                        </span>
                                    </div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            gap: '10px',
                                        }}
                                    >
                                        <span
                                            style={{
                                                color: '#2F2B43',
                                                fontWeight: '500',
                                                fontSize: '16px',
                                            }}
                                        >
                                            {getText('msg_73f99846cebe')}
                                        </span>
                                        <div className="form-switch">
                                            <input
                                                onClick={() =>
                                                    setDisplayTitle(
                                                        !displayTitle,
                                                    )
                                                }
                                                className="form-check-input custom-switch-input"
                                                type="checkbox"
                                                checked={displayTitle}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <input
                                    onChange={handleNameChange}
                                    defaultValue={name}
                                    style={{
                                        height: '48px',
                                        borderRadius: '12px',
                                        border: 'solid 1px rgba(47, 43, 67, 0.2)',
                                        paddingLeft: '16px',
                                        paddingRight: '16px',
                                    }}
                                    className="form-control"
                                    type="text"
                                    placeholder={getText('msg_292565e779ee')}
                                    aria-label={getText('msg_292565e779ee')}
                                />
                                <div
                                    style={{
                                        fontSize: '14px',
                                        fontWeight: '400',
                                        textAlign: 'left',
                                        color: nameCharacterLimitStatus,
                                        marginLeft: '8px',
                                        marginTop: '8px',
                                    }}
                                >
                                    {nameCharacterLimitLabel}
                                </div>

                                {/*DUE DATE*/}
                                {(item.type === ContainerTypes.AssetUpload ||
                                    item.type === ContainerTypes.Document ||
                                    item.type === ContainerTypes.Link ||
                                    item.type === ContainerTypes.Multimedia ||
                                    item.type === ContainerTypes.Video) &&
                                    clientTierMeetsRequirement(
                                        TenantTiers.Silver,
                                    ) && (
                                        <>
                                            <hr
                                                style={{
                                                    marginTop: '20px',
                                                    color: 'rgba(217, 217, 217, 1)',
                                                    display: isSaving
                                                        ? 'none'
                                                        : 'block',
                                                }}
                                            />
                                            <div
                                                style={{
                                                    width: '100%',
                                                    minWidth: '184px',
                                                    marginTop: '26px',
                                                    display:
                                                        uploadFromDevice ||
                                                        addFromAssets
                                                            ? 'none'
                                                            : 'block',
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: '16px',
                                                        fontWeight: '500',
                                                        color: 'rgba(47, 43, 67, 1)',
                                                        marginBottom: '10px',
                                                    }}
                                                >
                                                    {getText('msg_a1b308ec704a')}
                                                    {item.type ===
                                                        ContainerTypes.AssetUpload && (
                                                        <span
                                                            style={{
                                                                color: '#EF4E45',
                                                                marginLeft:
                                                                    '4px',
                                                                fontWeight:
                                                                    '500',
                                                            }}
                                                        >
                                                            *
                                                        </span>
                                                    )}
                                                </div>
                                                <CustomDatePicker
                                                    selectedDate={dueDate}
                                                    onDateChange={
                                                        handleDueDateChange
                                                    }
                                                />
                                            </div>
                                        </>
                                    )}

                                {/*ACKNOWLEDGMENT*/}
                                {(item.type === ContainerTypes.Table ||
                                    item.type === ContainerTypes.Document ||
                                    item.type ===
                                        ContainerTypes.EnrollmentByAge ||
                                    item.type === ContainerTypes.Image ||
                                    item.type === ContainerTypes.Link ||
                                    item.type === ContainerTypes.Multimedia ||
                                    item.type === ContainerTypes.Text ||
                                    item.type ===
                                        ContainerTypes.PremiumByPlanType ||
                                    item.type === ContainerTypes.Video) &&
                                    clientTierMeetsRequirement(
                                        TenantTiers.Silver,
                                    ) && (
                                        <>
                                            <hr
                                                style={{
                                                    marginTop: '20px',
                                                    color: 'rgba(217, 217, 217, 1)',
                                                    display: isSaving
                                                        ? 'none'
                                                        : 'block',
                                                }}
                                            />
                                            <div
                                                style={{
                                                    display:
                                                        uploadFromDevice ||
                                                        addFromAssets
                                                            ? 'none'
                                                            : 'flex',
                                                    flexDirection: 'row',
                                                    gap: '10px',
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        color: '#2F2B43',
                                                        fontWeight: '500',
                                                        fontSize: '16px',
                                                    }}
                                                >
                                                    {getText('msg_1c8938e86631')}
                                                    {visibilityTextAreaAcknowledgementRequired && (
                                                        <span
                                                            style={{
                                                                color: '#EF4E45',
                                                                marginLeft:
                                                                    '4px',
                                                                fontWeight:
                                                                    '500',
                                                            }}
                                                        >
                                                            *
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="form-switch">
                                                    <input
                                                        onClick={() =>
                                                            setVisibilityTextAreaAcknowledgementRequired(
                                                                !visibilityTextAreaAcknowledgementRequired,
                                                            )
                                                        }
                                                        className="form-check-input custom-switch-input"
                                                        type="checkbox"
                                                        checked={
                                                            visibilityTextAreaAcknowledgementRequired
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <span
                                                style={{
                                                    display: !(
                                                        uploadFromDevice ||
                                                        addFromAssets
                                                    )
                                                        ? 'block'
                                                        : 'none',
                                                    marginTop: '10px',
                                                }}
                                            >
                                                <textarea
                                                    id="ackText"
                                                    className="form-control"
                                                    placeholder={getText('msg_c88101d51c8f')}
                                                    style={{
                                                        height: '100px',
                                                        borderRadius: '12px',
                                                        border: 'solid 1px rgba(47, 43, 67, 0.2)',
                                                        resize: 'none',
                                                        padding: '16px',
                                                    }}
                                                    value={acknowledgmentText}
                                                    onChange={e =>
                                                        setAcknowledgmentText(
                                                            e.target.value,
                                                        )
                                                    }
                                                    disabled={
                                                        !visibilityTextAreaAcknowledgementRequired
                                                    }
                                                ></textarea>
                                            </span>
                                        </>
                                    )}

                                {/* HIDDEN FOR NOW - TICKET 57359 */}
                                {/* ADDITIONAL INFORMATION CHECKBOX AND TEXT FIELD */}
                                {/* {item.type != ContainerTypes.Link && (
                                    <>
                                        <div
                                            style={{
                                                margin: '26px 0px 0px 0px',
                                                display:
                                                    uploadFromDevice || addFromAssets
                                                        ? 'none'
                                                        : 'flex',
                                                alignItems: 'center',
                                                lineHeight: '28px',
                                            }}
                                        >
                                            <input
                                                id="helpBoxCheckbox"
                                                type="checkbox"
                                                className="form-check-input custom-checkbox"
                                                defaultChecked={
                                                    item.type ===
                                                    ContainerTypes.AssetUpload
                                                } // If container is asset Upload, additional information is checked by default
                                                onChange={() =>
                                                    setVisibilityTextAreaAdditionalInformation(
                                                        !visibilityTextAreaAdditionalInformation,
                                                    )
                                                }
                                            />
                                            <span
                                                style={{
                                                    color: '#2F2B43',
                                                    fontWeight: '500',
                                                    fontSize: '16px',
                                                }}
                                            >
                                                Additional Information
                                            </span>
                                        </div>
                                        <span
                                            style={{
                                                display:
                                                    visibilityTextAreaAdditionalInformation &&
                                                    !(uploadFromDevice || addFromAssets)
                                                        ? 'block'
                                                        : 'none',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: '16px',
                                                    fontWeight: '400',
                                                    color: 'rgba(47, 43, 67, 1)',
                                                    margin: '10px 0',
                                                }}
                                            >
                                                Additional Information Text
                                                <span
                                                    style={{
                                                        color: '#EF4E45',
                                                        marginLeft: '4px',
                                                        fontWeight: '500',
                                                    }}
                                                >
                                                    *
                                                </span>
                                            </div>
                                            <textarea
                                                id="helpBoxText"
                                                className="form-control"
                                                placeholder="Enter additional details to be displayed on the Additional Information banner at the bottom of the container"
                                                defaultValue={
                                                    item.type ===
                                                    ContainerTypes.AssetUpload
                                                        ? 'Assets may be shared with authorized individuals for official purposes. You can view this in Assets.'
                                                        : ''
                                                }
                                                style={{
                                                    height: '100px',
                                                    borderRadius: '12px',
                                                    border: 'solid 1px rgba(47, 43, 67, 0.2)',
                                                    resize: 'none',
                                                    padding: '16px',
                                                }}
                                            ></textarea>
                                        </span>
                                    </>
                                )} */}
                            </div>
                        )}

                        {/*CONTAINER-SPECIFIC HEADER FIELDS SECTION*/}
                        {activeTab === TABS.HEADER && (
                            <div>{renderContainerSpecificFields()}</div>
                        )}

                        {/*CONTAINER-SPECIFIC CONTENT FIELDS SECTION*/}
                        {activeTab === TABS.CONTENT && (
                            <div>{renderContentProperties()}</div>
                        )}

                        {/*CONTAINER-SPECIFIC BUTTON FIELDS SECTION*/}
                        {activeTab === TABS.BUTTON && (
                            <div>{renderButtonProperties()}</div>
                        )}

                        {/*CONTAINER-SPECIFIC UPLOAD FIELDS SECTION*/}
                        {activeTab === TABS.UPLOAD && (
                            <div>{renderUploadProperties()}</div>
                        )}

                        {/*CONTAINER-SPECIFIC REQUEST FIELDS SECTION*/}
                        {activeTab === TABS.REQUEST && (
                            <div>{renderRequestProperties()}</div>
                        )}

                        {/*CONTAINER-SPECIFIC LINK FIELDS SECTION*/}
                        {activeTab === TABS.LINK && (
                            <div>{renderLinkProperties()}</div>
                        )}

                        {/*CONTAINER-SPECIFIC FORMAT FIELDS SECTION*/}
                        {activeTab === TABS.FORMAT && (
                            <div>{renderFormatProperties()}</div>
                        )}
                    </div>

                    <hr
                        style={{
                            margin: '0px',
                            color: 'rgba(217, 217, 217, 1)',
                            display: isSaving ? 'none' : 'block',
                        }}
                    />

                    {!(uploadFromDevice || addFromAssets) && (
                        <div
                            id="footer"
                            style={{
                                height: 'fit-content',
                                width: '100%',
                                padding: '28px',
                                display: isSaving ? 'none' : 'block',
                            }}
                        >
                            <div
                                className="float-start"
                                style={{ display: 'inline-block' }}
                            >
                                <span
                                    style={{
                                        color: '#EF4E45',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                    }}
                                >
                                    *
                                </span>
                                <span
                                    style={{
                                        color: '#000000',
                                        fontSize: '14px',
                                        fontWeight: '400',
                                    }}
                                >
                                    {getText('msg_04148d61b0b7')}
                                </span>
                            </div>
                            {!hasAttribute(
                                SecurityAttributes.PortalsReadOnly,
                            ) && (
                                <div
                                    type="button"
                                    style={{
                                        height: '40px',
                                        width: '128px',
                                        textAlign: 'center',
                                        display: 'inline-block',
                                    }}
                                    className="float-end button-base ing-button-primary-left"
                                    onClick={() => saveChanges()}
                                >
                                    {getText('msg_efc007a393f6')}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
